import React from 'react';
import PropTypes from 'prop-types';

const Accordion = (props) => {
  return (
    <>
      <div className="accordion" id="accordionPanelsStayOpenExample">
        <div className="faq-question">
          <div className="container">
            <div className="row">
              <h3 className="sub-title-heading pb-4">{props.heading}</h3>
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      What is included with my membership?
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="accordion-body">
                      <div className="font-list-civil">
                        <ul>
                          <li>
                            Online reservation access and priority check-in at
                            all Participating Network Ranges.
                          </li>
                          <li>
                            Discounts on Standard Range time, including FREE
                            Standard Passes at Participating Network Ranges.
                          </li>
                          <li>
                            Preferred pricing up to 50% OFF on Range Time
                            Accessories, including firearm rentals, targets and
                            eye/ear protection.
                          </li>
                          <li>
                            “Bring a Friend” preferred pricing for your guests.
                          </li>
                          <li>Loyalty points earned with every visit.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne1">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne1"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How do I reset my password?
                    </button>
                  </div>
                  <div
                    id="collapseOne1"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne1"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p className="body-title">
                        Click the Reset your password link below the password
                        section on your member login portal.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne2">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne2"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Can I pay my membership monthly?
                    </button>
                  </div>
                  <div
                    id="collapseOne2"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne2"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p className="body-title">
                        Yes! You have the option to pay your membership either
                        monthly or annually.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <div className="accordion-header " id="headingOne5">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne5"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How long does it take for me to use my benefits?
                    </button>
                  </div>
                  <div
                    id="collapseOne5"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne5"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p className="body-title">
                        Once you have created a profile, you are ready to Make
                        It A Range Day!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <div className="accordion-header collapsed" id="headingOne7">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne7"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Can my local range become a Network Range?
                    </button>
                  </div>
                  <div
                    id="collapseOne7"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne7"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p className="body-title">
                        Yes, joining The Range Network is FREE for ranges!
                        Please have your range operator contact The Range
                        Network at:{' '}
                        <a
                          href="https://therangenetwork.com/join-now/"
                          target="__blank"
                        >
                          https://therangenetwork.com/join-now/
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne4"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Can I upgrade my level later?
                    </button>
                  </div>
                  <div
                    id="collapseOne4"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne4"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p className="body-title">
                        At this time we have the options to choose either:
                        monthly or annual memberships. If you would like to
                        convert your monthly membership into a yearly
                        membership, please contact us at:{' '}
                        <a href="mailto:info@mycalibercard.com">
                          info@mycalibercard.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
Accordion.propTypes = {
  heading: PropTypes.string,
};

export default Accordion;
